import { AuditAudio, removeIndex } from '@mi-front/core';
import debugFn from 'debug';
import dotProp from 'dot-prop-immutable';
import { UploadState } from '../../types';

const debug = debugFn('audit:upload');

export interface ViewState {
  readonly uploads: readonly UploadState[];
  readonly status: 'NOT_STARTED' | 'STARTED' | 'COMPLETED';
}

export const initialState: ViewState = {
  uploads: [],
  status: 'NOT_STARTED',
};

export type UploadAction =
  | { type: 'ALL_ADD'; payload: readonly File[] }
  | { type: 'ALL_STARTED' }
  | { type: 'ALL_RESET' }
  | { type: 'ALL_COMPLETED' }
  | { type: 'UPLOAD_UPDATE_ID'; payload: { index: number; value: string } }
  | { type: 'UPLOAD_REMOVE'; payload: { index: number } }
  | { type: 'UPLOAD_STARTED'; payload: { index: number } }
  | { type: 'UPLOAD_PROGRESS'; payload: { index: number; progress: number } }
  | {
      type: 'UPLOAD_COMPLETED';
      payload: { index: number; overridden?: AuditAudio };
    }
  | { type: 'UPLOAD_ERROR'; payload: { index: number; error: Error } };

export function viewReducer(state: ViewState, action: UploadAction): ViewState {
  debug(action.type, { state: state, action });
  switch (action.type) {
    case 'ALL_ADD':
      return {
        ...state,
        uploads: action.payload.map((file: File) => ({
          file,
          progress: 0,
          status: 'NOT_STARTED',
          audioId: file.name.split('.').slice(0, -1).join('.'),
        })),
      };
    case 'ALL_STARTED':
      return {
        ...state,
        status: 'STARTED',
      };
    case 'ALL_RESET':
      return initialState;
    case 'ALL_COMPLETED':
      return {
        ...state,
        status: 'COMPLETED',
      };
    case 'UPLOAD_REMOVE':
      return {
        ...state,
        uploads: removeIndex(state.uploads, action.payload.index),
      };
    case 'UPLOAD_UPDATE_ID':
      return {
        ...state,
        uploads: dotProp.merge(state.uploads, action.payload.index, {
          audioId: action.payload.value,
        }),
      };
    case 'UPLOAD_STARTED':
      return {
        ...state,
        uploads: dotProp.merge(state.uploads, action.payload.index, {
          status: 'STARTED',
        }),
      };
    case 'UPLOAD_PROGRESS':
      return {
        ...state,
        uploads: dotProp.merge(state.uploads, action.payload.index, {
          progress: action.payload.progress,
        }),
      };
    case 'UPLOAD_COMPLETED':
      return {
        ...state,
        uploads: dotProp.merge(state.uploads, action.payload.index, {
          status: 'COMPLETED',
          overridden: action.payload.overridden,
        }),
      };
    case 'UPLOAD_ERROR':
      return {
        ...state,
        uploads: dotProp.merge(state.uploads, action.payload.index, {
          status: 'ERROR',
          error: action.payload.error,
        }),
      };
    default:
      return state;
  }
}
